
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1600","height":"1600","viewBox":"0 0 1200 1200","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M414.72 823.56l-43.078 65.641h268.68L597.24 823.56zM1125.4 889.2l-26.16-51.238a26.393 26.393 0 00-24-14.403H953.8L920.32 889.2zM1011.1 739.08h-50.16v66.48h82.199v-34.438a32.161 32.161 0 00-32.039-32.043zM591 805.56v-66.48H324a114.521 114.521 0 0118.121 61.801v4.68zM111.48 800.88c0-21.91 6.29-43.355 18.121-61.801H68.999v32.762c0 8.941 3.55 17.52 9.875 23.844a33.72 33.72 0 0023.844 9.875h9c0-1.559-.238-3.117-.238-4.68zM69 721.08h75a114.96 114.96 0 0183.102-35.52c31.387 0 61.41 12.832 83.098 35.52H591V354a43.317 43.317 0 00-43.2-43.2H112.2A43.324 43.324 0 0069 354zM942.96 805.56v-66.48h-64.441a114.521 114.521 0 0118.121 61.801v4.68zM609 401.76v319.32h89.16a114.96 114.96 0 0183.102-35.52c31.387 0 61.41 12.832 83.098 35.52h78.602v-96l-91.68-223.32zm266.04 211.8a17.763 17.763 0 01-15 8.043H682.56a18.002 18.002 0 01-18-18v-130.32a18.001 18.001 0 0118-18H804a18.088 18.088 0 019.906 2.992 18.106 18.106 0 016.653 7.926l55.922 130.32a17.876 17.876 0 01-1.442 17.04zM666 800.88a114.502 114.502 0 0118-61.801h-75v66.48h57.238c-.117-1.559-.238-3.117-.238-4.68z"}}),_c('path',{attrs:{"d":"M682.56 473.28V603.6h177.48l-55.918-130.32zM324.12 800.88c0 53.75-43.574 97.32-97.32 97.32-53.75 0-97.32-43.57-97.32-97.32 0-53.746 43.57-97.32 97.32-97.32 53.746 0 97.32 43.574 97.32 97.32M878.64 800.88c0 53.75-43.574 97.32-97.32 97.32-53.75 0-97.32-43.57-97.32-97.32 0-53.746 43.57-97.32 97.32-97.32 53.746 0 97.32 43.574 97.32 97.32"}})])
          )
        }
      }
    